<template>
  <ModalDialog
    v-if="isShow"
    title="加入對戰"
    :hide-cancel="true"
    confirm-text="確定送出"
    :value="isShow"
    size="sm"
    no-content-gap
    @input="onInput"
    @confirm="joinLobby"
  >
    <b-form @submit.prevent="joinLobby">
      <b-form-input
        v-model="code"
        :placeholder="$t('請輸入對戰號碼')"
        autocomplete="off"
        autofocus
      ></b-form-input>
    </b-form>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/Modal/ModalDialog.vue';
import pvpService from '@/services/pvp.js';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalDialog,
  },
  computed: {
    isShow() {
      return this.$store.state.env.isJoinPvpModalShow;
    },
  },

  data() {
    return {
      code: '',
    };
  },
  methods: {
    async joinLobby() {
      this.$store.commit('env/setIsLoading', true);
      try {
        const id = this.code;
        await pvpService.enterLobby(id);
        this.code = '';
        this.$router.push({name: 'pvp-lobby', params: {id}});
        this.$store.commit('env/setIsSelectPvpActionModalShow', false);
      } catch (error) {
        this.$alert(error?.message || error);
      }
      this.$emit('input', false);
      this.$store.commit('env/setIsLoading', false);
    },
    onInput() {
      if (this.isCreating) return;
      this.$store.commit('env/setIsJoinPvpModalShow', false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
